// extracted by mini-css-extract-plugin
module.exports = {"container":"Container-module--container--1KxIh","containerSmall":"Container-module--container--small--x4ryX"};